module.exports = __webpack_public_path__ + "static/media/cracked.b5aef39d.svg";